import { FinanceInsurancePerformanceReportGroupBy, FinanceDateRange, PerformanceRow } from './types';

export const DATE_RANGE_OPTIONS: { value: FinanceDateRange; label: string }[] = [
  { value: 'cm', label: 'This mo' },
  { value: 'lm', label: 'Last mo' },
  { value: 'cq', label: 'This qtr' },
  { value: 'lq', label: 'Last qtr' },
  { value: '30', label: '30d' },
  { value: '90', label: '3 mo' },
  { value: '180', label: '6 mo' },
  { value: '365', label: '1 yr' },
  { value: 'custom', label: 'Custom' },
];

export const GROUP_BY_OPTIONS: { value: FinanceInsurancePerformanceReportGroupBy; label: string }[] = [
  { value: FinanceInsurancePerformanceReportGroupBy.SalesRep, label: 'Sales Rep' },
  { value: FinanceInsurancePerformanceReportGroupBy.Location, label: 'Location' },
  { value: FinanceInsurancePerformanceReportGroupBy.FinanceMgr, label: 'Finance Mgr' },
  { value: FinanceInsurancePerformanceReportGroupBy.SalesMgr, label: 'Sales Mgr' },
];

export const MOCKED_ROWS: Record<FinanceInsurancePerformanceReportGroupBy, PerformanceRow[]> = {
  [FinanceInsurancePerformanceReportGroupBy.SalesRep]: [
    {
      name: 'Mike Torres',
      deals: 42,
      fiDeals: 34,
      financePenetration: 71,
      escPenetration: 52,
      insurancePenetration: 38,
      gapPenetration: 24,
      roadsidePenetration: 14,
      financeProfit: 84200,
      escProfit: 31400,
      insuranceProfit: 18900,
      gapProfit: 9800,
      roadsideProfit: 4200,
    },
    {
      name: 'Sarah Chen',
      deals: 38,
      fiDeals: 35,
      financePenetration: 82,
      escPenetration: 61,
      insurancePenetration: 45,
      gapPenetration: 32,
      roadsidePenetration: 18,
      financeProfit: 96500,
      escProfit: 38200,
      insuranceProfit: 22100,
      gapProfit: 14500,
      roadsideProfit: 6100,
    },
    {
      name: 'James Wilson',
      deals: 31,
      fiDeals: 22,
      financePenetration: 58,
      escPenetration: 42,
      insurancePenetration: 29,
      gapPenetration: 16,
      roadsidePenetration: 10,
      financeProfit: 52300,
      escProfit: 21800,
      insuranceProfit: 12400,
      gapProfit: 5200,
      roadsideProfit: 2800,
    },
    {
      name: 'Kayla Brown',
      deals: 47,
      fiDeals: 41,
      financePenetration: 76,
      escPenetration: 57,
      insurancePenetration: 41,
      gapPenetration: 28,
      roadsidePenetration: 19,
      financeProfit: 112800,
      escProfit: 44100,
      insuranceProfit: 25600,
      gapProfit: 16200,
      roadsideProfit: 7400,
    },
    {
      name: 'David Park',
      deals: 25,
      fiDeals: 19,
      financePenetration: 64,
      escPenetration: 48,
      insurancePenetration: 36,
      gapPenetration: 20,
      roadsidePenetration: 8,
      financeProfit: 41200,
      escProfit: 18600,
      insuranceProfit: 11200,
      gapProfit: 5800,
      roadsideProfit: 1900,
    },
    {
      name: 'Lisa Martinez',
      deals: 36,
      fiDeals: 28,
      financePenetration: 69,
      escPenetration: 44,
      insurancePenetration: 31,
      gapPenetration: 22,
      roadsidePenetration: 12,
      financeProfit: 68400,
      escProfit: 24800,
      insuranceProfit: 14600,
      gapProfit: 8400,
      roadsideProfit: 3600,
    },
    {
      name: 'Ryan Cooper',
      deals: 29,
      fiDeals: 18,
      financePenetration: 55,
      escPenetration: 38,
      insurancePenetration: 25,
      gapPenetration: 14,
      roadsidePenetration: 6,
      financeProfit: 38900,
      escProfit: 16200,
      insuranceProfit: 9100,
      gapProfit: 4100,
      roadsideProfit: 1500,
    },
    {
      name: 'Angela Rivera',
      deals: 44,
      fiDeals: 39,
      financePenetration: 79,
      escPenetration: 59,
      insurancePenetration: 43,
      gapPenetration: 30,
      roadsidePenetration: 16,
      financeProfit: 105600,
      escProfit: 41500,
      insuranceProfit: 24300,
      gapProfit: 15100,
      roadsideProfit: 6800,
    },
    {
      name: 'Tom Nakamura',
      deals: 33,
      fiDeals: 24,
      financePenetration: 62,
      escPenetration: 46,
      insurancePenetration: 33,
      gapPenetration: 18,
      roadsidePenetration: 11,
      financeProfit: 56800,
      escProfit: 23400,
      insuranceProfit: 13800,
      gapProfit: 6400,
      roadsideProfit: 3100,
    },
    {
      name: 'Beth Hoffman',
      deals: 21,
      fiDeals: 12,
      financePenetration: 48,
      escPenetration: 33,
      insurancePenetration: 21,
      gapPenetration: 10,
      roadsidePenetration: 5,
      financeProfit: 28100,
      escProfit: 11200,
      insuranceProfit: 6400,
      gapProfit: 2800,
      roadsideProfit: 900,
    },
    {
      name: 'Carlos Vega',
      deals: 39,
      fiDeals: 33,
      financePenetration: 74,
      escPenetration: 55,
      insurancePenetration: 40,
      gapPenetration: 26,
      roadsidePenetration: 15,
      financeProfit: 89200,
      escProfit: 35600,
      insuranceProfit: 20800,
      gapProfit: 12400,
      roadsideProfit: 5200,
    },
    {
      name: 'Priya Sharma',
      deals: 28,
      fiDeals: 20,
      financePenetration: 61,
      escPenetration: 43,
      insurancePenetration: 30,
      gapPenetration: 17,
      roadsidePenetration: 9,
      financeProfit: 46500,
      escProfit: 19800,
      insuranceProfit: 11600,
      gapProfit: 5600,
      roadsideProfit: 2400,
    },
  ],
  LOCATION: [
    {
      name: 'Dallas, TX',
      deals: 95,
      fiDeals: 78,
      financePenetration: 73,
      escPenetration: 54,
      insurancePenetration: 39,
      gapPenetration: 26,
      roadsidePenetration: 14,
      financeProfit: 198200,
      escProfit: 78400,
      insuranceProfit: 45200,
      gapProfit: 28600,
      roadsideProfit: 12100,
    },
    {
      name: 'Houston, TX',
      deals: 82,
      fiDeals: 62,
      financePenetration: 68,
      escPenetration: 48,
      insurancePenetration: 34,
      gapPenetration: 21,
      roadsidePenetration: 11,
      financeProfit: 162400,
      escProfit: 61200,
      insuranceProfit: 36800,
      gapProfit: 20400,
      roadsideProfit: 8600,
    },
    {
      name: 'Atlanta, GA',
      deals: 71,
      fiDeals: 60,
      financePenetration: 75,
      escPenetration: 56,
      insurancePenetration: 42,
      gapPenetration: 29,
      roadsidePenetration: 17,
      financeProfit: 154800,
      escProfit: 64200,
      insuranceProfit: 38600,
      gapProfit: 24200,
      roadsideProfit: 10800,
    },
    {
      name: 'Charlotte, NC',
      deals: 64,
      fiDeals: 48,
      financePenetration: 66,
      escPenetration: 45,
      insurancePenetration: 31,
      gapPenetration: 19,
      roadsidePenetration: 10,
      financeProfit: 118600,
      escProfit: 46800,
      insuranceProfit: 27400,
      gapProfit: 14200,
      roadsideProfit: 5800,
    },
    {
      name: 'Nashville, TN',
      deals: 48,
      fiDeals: 38,
      financePenetration: 70,
      escPenetration: 50,
      insurancePenetration: 36,
      gapPenetration: 23,
      roadsidePenetration: 13,
      financeProfit: 96400,
      escProfit: 38600,
      insuranceProfit: 22800,
      gapProfit: 12800,
      roadsideProfit: 5400,
    },
    {
      name: 'Phoenix, AZ',
      deals: 53,
      fiDeals: 36,
      financePenetration: 59,
      escPenetration: 41,
      insurancePenetration: 28,
      gapPenetration: 15,
      roadsidePenetration: 7,
      financeProfit: 89800,
      escProfit: 34200,
      insuranceProfit: 19600,
      gapProfit: 9200,
      roadsideProfit: 3200,
    },
  ],
  FINANCE_MGR: [
    {
      name: 'Robert Kimball',
      deals: 88,
      fiDeals: 76,
      financePenetration: 78,
      escPenetration: 58,
      insurancePenetration: 43,
      gapPenetration: 30,
      roadsidePenetration: 17,
      financeProfit: 215400,
      escProfit: 86200,
      insuranceProfit: 50200,
      gapProfit: 31600,
      roadsideProfit: 13800,
    },
    {
      name: 'Diana Poole',
      deals: 102,
      fiDeals: 82,
      financePenetration: 72,
      escPenetration: 51,
      insurancePenetration: 37,
      gapPenetration: 24,
      roadsidePenetration: 13,
      financeProfit: 232600,
      escProfit: 84800,
      insuranceProfit: 49400,
      gapProfit: 28200,
      roadsideProfit: 11400,
    },
    {
      name: 'Marcus Reeves',
      deals: 76,
      fiDeals: 54,
      financePenetration: 65,
      escPenetration: 44,
      insurancePenetration: 30,
      gapPenetration: 18,
      roadsidePenetration: 9,
      financeProfit: 148200,
      escProfit: 52400,
      insuranceProfit: 30600,
      gapProfit: 15800,
      roadsideProfit: 6200,
    },
    {
      name: 'Jennifer Tan',
      deals: 62,
      fiDeals: 48,
      financePenetration: 69,
      escPenetration: 49,
      insurancePenetration: 35,
      gapPenetration: 22,
      roadsidePenetration: 11,
      financeProfit: 124000,
      escProfit: 49200,
      insuranceProfit: 28800,
      gapProfit: 16000,
      roadsideProfit: 6800,
    },
  ],
  SALES_MGR: [
    {
      name: 'Greg Bledsoe',
      deals: 145,
      fiDeals: 112,
      financePenetration: 71,
      escPenetration: 52,
      insurancePenetration: 38,
      gapPenetration: 25,
      roadsidePenetration: 14,
      financeProfit: 312400,
      escProfit: 121800,
      insuranceProfit: 71200,
      gapProfit: 42800,
      roadsideProfit: 17600,
    },
    {
      name: 'Kim Nguyen',
      deals: 128,
      fiDeals: 104,
      financePenetration: 74,
      escPenetration: 55,
      insurancePenetration: 40,
      gapPenetration: 27,
      roadsidePenetration: 15,
      financeProfit: 298800,
      escProfit: 118200,
      insuranceProfit: 68600,
      gapProfit: 40200,
      roadsideProfit: 16800,
    },
    {
      name: 'Steve Dalton',
      deals: 140,
      fiDeals: 102,
      financePenetration: 67,
      escPenetration: 46,
      insurancePenetration: 32,
      gapPenetration: 19,
      roadsidePenetration: 10,
      financeProfit: 264600,
      escProfit: 98400,
      insuranceProfit: 57200,
      gapProfit: 29400,
      roadsideProfit: 11200,
    },
  ],
};
